import React from "react";
import "../components/MacWindow.css";
import Draggable from "react-draggable";
import Container from "react-bootstrap/Container";
// import './draggable.js';

export default function Achievements({ onClose }) {
  return (
    <Draggable handle=".windowheader">
      <div className="draggable-container">
        <div class="window">
          <div class="windowheader">
            <div class="wrapper">
              <div class="nav-buttons">
                <div class="close" onClick={onClose}></div>
                <div class="minimize"></div>
                <div class="expand"></div>
              </div>
              <div class="title">Achievements</div>
            </div>
          </div>

          <div class="body">
            <Container
              style={{ maxHeight: "300px", overflowY: "auto" }}
              id="style-1"
              className="scrollbar"
            >
              <div className="text">
                <ol>
                  <li>
                    Selected as an open-source <b>project admin</b> at Vinyasa Summer
                    of Code for the project <b>Open-Source Galaxy</b>, VSoC (2024){" "}
                  </li>
                  <li>
                    Successfully solved open-source issues and scored <b>160 points</b>
                    in GirlsScript Summer of Code, GSSoC, (May 2024){" "}
                  </li>
                  <li>
                    Reached <b>400+ downloads</b> on the first week of deploying my own
                    <b>npm starter command</b>, Npm, (Apr 2024){" "}
                  </li>
                  <li>
                    Won <b>'All in Open-Source Hackathon'</b> by MLH for the <b>Best use
                    of Auth0</b>, Virtual, (Mar 2024){" "}
                  </li>
                  <li>
                    Excelled as an <b>AWS AI & ML Scholar (Summer '23)</b>, showcasing
                    expertise in advanced AI and ML techniques{" "}
                  </li>
                  <li>
                    Championed Codeathon at <b>AURGANON '23</b>, a National Level
                    Symposium, SRM (2023){" "}
                  </li>
                  <li>
                    Took Part in <b>Codejam Kickstart Farewell round</b>, demonstrating
                    strong problem-solving abilities and programming skills,
                    Google Codejam (2023)
                  </li>
                  <li>
                    Immersed in the world of <b>Google Cloud Platform</b> and Cloud
                    technologies through active involvement in Google Cloud
                    Facilllitator (2022)
                  </li>
                  <li>
                    Secured <b>3rd rank</b> in the higher secondary examinations,
                    evidenced outstanding intellectual capabilities (2021)
                  </li>
                  <li>
                    Secured <b>Centum in Computer Science Subject</b> during my 11th
                    grade (2020)
                  </li>
                </ol>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Draggable>
  );
}
